import React from 'react'

const CSS = () => {
  return (
    <div>CSS</div>
  )
}

export default CSS